// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { PartsListModel } from "@store/Framework/Types/ApiModels";

const productsUrl = "/api/v1/products";

export function getPartsList(parameter: string) {
    try {
        return get<string[]>(`${productsUrl}/${parameter}/parts`);
    } catch (error) {
        global.console.error("Error fetching parts list:", error);
        throw new Error("Failed to fetch parts list. Please try again later.");
    }
}
